import React, { CSSProperties, ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';
import { vars } from '../../../theme';
import colors from '../../../styles/colors';
import { ISideNavTheme } from '../context/useCreateTheme';

export type SideNavMenuProps = {
    children?: ReactNode;
    theme?: ISideNavTheme;
    width?: CSSProperties['width'];
    height?: CSSProperties['height'];
    padding?: CSSProperties['padding'];
};

const HBSideNavMenu = ({
    children,
    theme,
    width,
    height,
    padding
}: SideNavMenuProps) => {
    return (
        <StyledMenu
            $theme={theme}
            $width={width}
            $height={height}
            $padding={padding}
        >
            {children}
        </StyledMenu>
    );
};

export default HBSideNavMenu;

// -------------------------------- Styles -------------------------------- //

const scaleIn = keyframes({
    from: {
        opacity: 0.7
    },
    to: {
        opacity: 1
    }
});

const StyledMenu = styled.div<{
    $theme?: SideNavMenuProps['theme'];
    $width?: SideNavMenuProps['width'];
    $height?: SideNavMenuProps['height'];
    $padding?: SideNavMenuProps['padding'];
}>`
    ${({ $theme }) =>
        `background-color: ${$theme.backgroundColor};
        color: ${$theme.itemTextColor};`};
    ${({ $width }) => $width && `width: ${$width};`};
    ${({ $height }) => $height && `height: ${$height};`};
    padding: ${({ $padding }) => $padding ?? '8px 6px'};
    min-width: 200px;
    border-radius: ${vars.radius.sm};
    box-shadow: 0 0 40px ${colors.black_04};
    overflow: hidden;
    transform-origin: var(--radix-popover-content-transform-origin);
    animation: ${scaleIn} 200ms linear;
`;
